import React, { Component } from 'react'
import { connect } from 'react-redux'
// import html2canvas from 'html2canvas'

import WindowSpinner from './WindowSpinner'
import Map from './Map'
import Filters from './Dashboard/Filters'
import Hole from './Dashboard/Hole'
import Export from './Dashboard/Export'
import Massive from './Dashboard/Massive'
import ImageViewer from './Dashboard/ImageViewer'
import Missions from './Dashboard/Missions'

import {
  callDetails,
  changeClusterSize,
  loadAttributes,
  switchImageLayer,
  switchHoleLayer,
  changeMapCenter,
  toggleCertifiedPhotos
} from '../actions'
import { uiConstants, pagesConstants } from '../constants'
import { uiHelper } from '../helpers'

const initialState = {
  showForm: false,
  showDetails: false,
  showExport: false,
  showMassive: false,
  showImage: false,
  index: -1,
  imageIndex: -1,
  onlyCertifiedImages: false
}

class Dashboard extends Component {
  constructor() {
    super()
    this.state = initialState
    this.escFunction = this.escFunction.bind(this)
    this.showSearchForm = this.showSearchForm.bind(this)
    this.showExportForm = this.showExportForm.bind(this)
    this.showMassiveForm = this.showMassiveForm.bind(this)
    this.markerClick = this.markerClick.bind(this)
    this.imageClick = this.imageClick.bind(this)
    this.hideDetails = this.hideDetails.bind(this)
    this.changeHole = this.changeHole.bind(this)
    this.endsHole = this.endsHole.bind(this)
    this.showImageForm = this.showImageForm.bind(this)
    this.nextImage = this.nextImage.bind(this)
    this.endsImage = this.endsImage.bind(this)
    this.clusterClick = this.clusterClick.bind(this)
    this.goAnomalyFromImage = this.goAnomalyFromImage.bind(this)
  }

  escFunction(event) {
    if (!event.target.name) {
      switch (event.keyCode) {
        case 27:
          this.hideDetails()
          break
        case 37:
          this.changeHole(-1)
          break
        case 39:
          this.changeHole(1)
          break
        default:
          break
      }
    }
  }

  hideDetails() {
    this.setState(initialState)
  }

  changeHole(dir) {
    if (this.state.index > -1) {
      const list = this.props.dashboard.list
      let ni = this.state.index + dir
      if (ni >= list.length) {
        ni = 0
      } else if (ni < 0) {
        ni = list.length - 1
      }
      const h = list[ni]
      this.markerClick(h.id)
    }
  }

  endsHole(dir) {
    const i = dir === 1 ? this.props.dashboard.list.length - 1 : 0
    const h = this.props.dashboard.list[i]
    this.markerClick(h.id)
  }

  showSearchForm(forceHide = false) {
    if (this.state.showForm || forceHide) {
      this.setState({ showForm: false })
    } else {
      this.setState({ showForm: true })
    }
  }

  showExportForm(forceHide = false) {
    if (this.state.showExport || forceHide) {
      this.setState({ showExport: false })
    } else {
      this.setState({ showExport: true })
    }
  }

  showMassiveForm(forceHide = false) {
    if (this.state.showMassive || forceHide) {
      this.setState({ showMassive: false })
    } else {
      this.setState({ showMassive: true })
    }
  }

  showImageForm(forceHide = false) {
    if (this.state.showImage || forceHide) {
      this.setState({ showImage: false })
    } else {
      this.setState({ showImage: true })
    }
  }

  markerClick(id) {
    const index = this.props.dashboard.list.findIndex((x) => x.id === id)
    this.setState({ showDetails: true, index })
    this.props.callDetails(id)
  }

  imageClick(image) {
    const { images, onlyCertifiedImages } = this.props.dashboard
    const filteredImages = (images || []).filter((x) => {
      return onlyCertifiedImages ? x.certified === 1 : true
    })
    const imageIndex = filteredImages.findIndex((x) => x.id === image.id)
    this.setState({ showImage: true, imageIndex })
  }

  clusterClick(e) {
    const lat = e.center.lat()
    const lng = e.center.lng()
    this.props.changeMapCenter({ lat, lng })
  }

  setClusterSize(s) {
    this.props.changeClusterSize(s)
  }

  // capture () {
  //   // html2canvas(document.body).then((canvas) => {
  //   //   // Export the canvas to its data URI representation
  //   //   var base64image = canvas.toDataURL('image/png')
  //   //   // Open the image in a new window
  //   //   window.open(base64image, '_blank')
  //   // })
  //   html2canvas(document.querySelector('#capture')).then(canvas => {
  //     document.body.appendChild(canvas)
  //   })
  // }

  toggleOnlyCertifiedImages(e) {
    this.setState({ onlyCertifiedImages: e.target.checked }, () => {
      this.props.toggleCertifiedPhotos()
    })
  }

  goAnomalyFromImage(id) {
    this.showImageForm(true)
    this.markerClick(id)
  }

  nextImage(dir) {
    const { images, onlyCertifiedImages } = this.props.dashboard
    const filteredImages = (images || []).filter((x) => {
      return onlyCertifiedImages ? x.certified === 1 : true
    })
    const s = this.state
    const nid = s.imageIndex + dir
    if (nid >= 0 && nid < filteredImages.length) {
      this.setState({
        imageIndex: nid
      })
    }
  }

  endsImage(dir) {
    const { images, onlyCertifiedImages } = this.props.dashboard
    const filteredImages = (images || []).filter((x) => {
      return onlyCertifiedImages ? x.certified === 1 : true
    })
    const i = dir === 1 ? filteredImages.length - 1 : 0
    this.setState({
      imageIndex: i
    })
  }

  componentDidUpdate(prevProps, prevState) {
    const p = prevProps
    const c = this.props
    if (
      p.dashboard.loading &&
      !c.dashboard.loading &&
      c.dashboard.error === null
    ) {
      this.showSearchForm(true)
      this.showMassiveForm(true)
      // this.showImageForm(true)
    }
    if (
      p.exportqueue.loading &&
      !c.exportqueue.loading &&
      c.exportqueue.error === null
    ) {
      this.showExportForm(true)
    }
  }

  componentDidMount() {
    if (this.props.attributes.dashboard === null) {
      this.props.loadAttributes(pagesConstants.dashboard)
    }
    this.setState({
      onlyCertifiedImages: this.props.dashboard.onlyCertifiedImages
    })
    document.addEventListener('keydown', this.escFunction, false)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false)
  }

  render() {
    const { showForm, showDetails, showExport, showMassive } = this.state
    const {
      list,
      clusterSize,
      loading,
      imagesLoading,
      showImagesButton,
      showImageLayer,
      showHoleLayer,
      images,
      onlyCertifiedImages
    } = this.props.dashboard
    const { canExport } = uiHelper.getActiveRole()
    const loadingLots = this.props.detections.loading
    const loadingExport = this.props.exportqueue.loading
    const s = this.state
    const filteredImages = (images || []).filter((x) => {
      return onlyCertifiedImages ? x.certified === 1 : true
    })
    return (
      <div>
        <button className='lnk-search' onClick={() => this.showSearchForm()}>
          <i className='fas fa-sliders-h'></i>
        </button>
        {list && list.length > 0 && canExport && (
          <button className='lnk-export' onClick={() => this.showExportForm()}>
            <i className='fas fa-download'></i>
          </button>
        )}
        {list && list.length > 0 && showImagesButton && (
          <button
            disabled={imagesLoading || (images && images.length === 0)}
            className={'lnk-images ' + (showImageLayer ? '' : ' inactive')}
            onClick={() => this.props.switchImageLayer()}
          >
            {imagesLoading && <i className='fas fa-sync fa-spin'></i>}
            {!imagesLoading && <i className='far fa-images'></i>}
          </button>
        )}
        {images && images.length > 0 && showImageLayer && (
          <div className='switch-cert-photos'>
            <label className='switch-certified'>
              <input
                type='checkbox'
                onChange={(e) => this.toggleOnlyCertifiedImages(e)}
                checked={s.onlyCertifiedImages}
              />
              <span className='slider round'></span>
            </label>
          </div>
        )}
        {list &&
          list.length > 0 &&
          uiHelper.canUse(uiConstants.grant.manageHole) && (
            <button
              className='lnk-massive-manage'
              onClick={() => this.showMassiveForm()}
            >
              <i className='fas fa-magic'></i>
            </button>
          )}
        {list && list.length > 0 && (
          <>
            <Missions />
            <button
              className={'lnk-holes ' + (showHoleLayer ? '' : ' inactive')}
              onClick={() => this.props.switchHoleLayer()}
            >
              <i className='fas fa-map-marked-alt'></i>
            </button>
            <span className='holes-counter'>
              {list.length.toLocaleString()}
            </span>
            <div className='range-container'>
              {uiConstants.clusterSizes.map((s, index) => {
                return (
                  <button
                    key={index}
                    onClick={() => this.setClusterSize(s)}
                    className={
                      'lnk-range ' + (clusterSize === s ? 'active' : '')
                    }
                  >
                    {s}
                  </button>
                )
              })}
            </div>
          </>
        )}
        {images && images.length > 0 && (
          <span className='images-counter'>
            {filteredImages.length.toLocaleString()}
          </span>
        )}
        {showForm && <Filters showSearchForm={this.showSearchForm} />}
        <Map
          css='with-nav'
          markerClick={this.markerClick}
          imageClick={this.imageClick}
          clusterClick={this.clusterClick}
          filteredImages={filteredImages}
        />
        {showDetails && (
          <Hole
            hideDetails={this.hideDetails}
            changeHole={this.changeHole}
            endsHole={this.endsHole}
            index={s.index}
          />
        )}
        {s.showImage && (
          <ImageViewer
            showImageForm={this.showImageForm}
            imageIndex={s.imageIndex}
            goAnomaly={this.goAnomalyFromImage}
            filteredImages={filteredImages}
            nextImage={this.nextImage}
            endsImage={this.endsImage}
          />
        )}
        {showExport && <Export showExportForm={this.showExportForm} />}
        {showMassive && <Massive showMassiveForm={this.showMassiveForm} />}
        {(loading || loadingLots || loadingExport) && <WindowSpinner />}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, {
  callDetails,
  changeClusterSize,
  loadAttributes,
  switchImageLayer,
  switchHoleLayer,
  changeMapCenter,
  toggleCertifiedPhotos
})(Dashboard)
